module.exports = __webpack_public_path__ + "img/Alexander_Ludwig.a4897b54.jpg";